import { computed, inject, Injectable, signal } from "@angular/core";
import { NotificationApiService } from "./notification.api.service";
import { of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NotificationStateService {

  
  private _apiService = inject(NotificationApiService);

  // Declaring our private signals
  private _notificationCount = signal<number | null>(null);

  private _hasLoaded = signal(false);

  //Public readonly getters
  public readonly notificationCount = computed(()=> this._notificationCount());
      

  constructor() {
    this.loadUnreadNotificationCount();
  }

  loadUnreadNotificationCount(): any {
    if (this._hasLoaded()) {
      return of(this._notificationCount());
    }
    return this._apiService.fetchUnreadNotificationCount().subscribe((data:any) => {
      this._notificationCount.set(data.count);
      this._hasLoaded.set(true);
    });
  }

}
